import { Component, OnInit, ViewChild } from '@angular/core';
import { PushNotificationService } from '@notification/push-notification.service';
import { FileInputComponent } from '@common/file-input/file-input';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MAX_FILE_SIZE, Maximum_image_upload_file_size_2mb , format_not_allowed} from '@root/app.constant';
import { MatDialog } from '@angular/material/dialog';
import { CropImageComponent } from '@common/crop-image/crop-image.component';
@Component({
  selector: 'app-create-notification',
  templateUrl: './create-notification.component.html',
  styleUrls: ['./create-notification.component.scss'],
  providers: [PushNotificationService],
})
export class CreateNotificationComponent implements OnInit {
  @ViewChild('f', { static: false }) form: NgForm;

  @ViewChild(FileInputComponent, { static: false })
  fileInputComponent: FileInputComponent;

  file: File;

  createNotoficationData = {
    title: '',
    description: '',
    fileName: '',
    linkId: '',
  };
  linkList = [
    {
      val: '1',
      name: 'Landing Screen',
    },
    {
      val: '2',
      name: 'Transact',
    },
    {
      val: '3',
      name: 'Transaction History',
    },
    {
      val: '4',
      name: 'Login',
    },
  ];

  croppedImage: any = '';

  constructor(
    private pushnotificationService: PushNotificationService,
    private toastr: ToastrService,
    public dialog: MatDialog) {}

  ngOnInit() {}

  onFileChange(file: File) {
    if (file) {
      this.file = file;

      if (this.file.type !== 'image/jpeg' && this.file.type !== 'image/png') {
        this.toastr.error(format_not_allowed);
        this.clearFileInput();
        return;
      }
      this.onEditImage( this.file)
    
    }
  }

  private clearFileInput(){
    this.file = null;
    if( this.fileInputComponent){
    this.fileInputComponent.clear();
    }
  }


  private onEditImage(file:File) {
    const dialogRef = this.dialog.open(CropImageComponent, {
      width:  '600px',
      data: { imageFile: file },
    });

    dialogRef.afterClosed().subscribe((response) => {
        this.croppedImage = response.croppedImage.base64;
        const file = this.base64ToFile(this.croppedImage, response.name);
        const fsize = this.file.size;
        if (fsize > MAX_FILE_SIZE) {
          this.clearFileInput();
          this.toastr.error(Maximum_image_upload_file_size_2mb);
          return;
        }
        this.file = file;
    });
  }


  private base64ToFile(data:any, filename:string) {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);

    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  processCreateData() {
    const formData: any = new FormData();
    if (this.file) {
      formData.append('file', this.file);
    }

    this.pushnotificationService
      .create(formData, this.createNotoficationData)
      .subscribe(
        (response) => {
          this.toastr.success(response.message);
          this.resetForm();
        },
        (error) => {
          this.toastr.error(error.errorMessage);
        }
      );
  }

  public resetForm() {
    if (this.form) {
      this.croppedImage =null;
      this.file = null;
      this.form.resetForm();
    }
  }

  /***
   * Name position validation
   */
  keyPressAlpha(event: any) {
    const pattern = /[a-zA-Z0-9 ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
